import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './useAuth'

export function RequireAuth() {
  const { isAuthenticated } = useAuth()
  const location = useLocation()
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }
  return <Outlet />
}

// Публичные страницы (login): авторизованных отправляем в профиль.
export function RequireAnon() {
  const { isAuthenticated } = useAuth()
  if (isAuthenticated) return <Navigate to="/profile" replace />
  return <Outlet />
}

export function RequireAdmin() {
  const { isAuthenticated, isAdmin } = useAuth()
  if (!isAuthenticated) return <Navigate to="/login" replace />
  if (!isAdmin) return <Navigate to="/profile" replace />
  return <Outlet />
}
